import { render } from "./AreasIndex.vue?vue&type=template&id=482b41bf&scoped=true"
import script from "./AreasIndex.vue?vue&type=script&lang=js"
export * from "./AreasIndex.vue?vue&type=script&lang=js"

import "./AreasIndex.vue?vue&type=style&index=0&id=482b41bf&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482b41bf"]])

export default __exports__